import React from "react";
import styled from "styled-components";
import profileImage from "../images/services.jpg";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column-reverse;
    background-color: #f3f2eaff;
    padding-bottom: 120px;
    padding: 400px 15px 30px;
    position: relative;

     @media (min-width: 1024px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 130px 0 50px;

     }
`;

const ImageWrapper = styled.div`
  img {
    height: 380px;
    width: -webkit-fill-available;
    object-fit: cover;
    margin-bottom: 20px;
    position: absolute; /* 👈 Take the image out of flex flow */
    top: 0;
    left: 0;

     @media (min-width: 1024px) {
    height: 500px;
    width: 40vw;
    margin-bottom: 0;
    position: unset;
     }
  }
`;

const Text = styled.div `
    font-family: Lato;
    font-size: 15px;

    ul {
      padding: 0 0 30px;
    }

    li {
      border-bottom: 1px solid #919090ff;
      padding: 15px 0 35px;
      list-style-type: none;
      display: flex;
      flex-direction: column;

      @media (min-width: 1024px) {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    p {
      margin: 10px 0 0;
    }

     @media (min-width: 1024px) {
      margin: 40px 60px 0 60px;
      width: 40vw;

      p {
        margin: 0;
        max-width: 59%;
      }

      li:first-of-type {
        border-top: 1px solid #919090ff;
      }
     }
`;

const CTAButton = styled.a`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    margin: 35px auto 40px;
    text-transform: uppercase;
    width: fit-content;
    padding: 0.75rem 2.2rem;
    border: 1px solid #919090ff;
    color: #3D3D3D;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: black;
      color: white;
    }
  }
`;


const Services = () => {
  const { t, i18n } = useTranslation();
  
    return (
      <Wrapper id="services">
        <Text>
          <ul>
            <li>
              <h3>{t("customWebsitesTitle")}</h3>
              <p>{t("customWebsitesText")}</p>
            </li>
            <li>
              <h3>{t("onlineShopsTitle")}</h3>
              <p>{t("onlineShopsText")}</p>
            </li>
            <li>
              <h3>{t("websiteRebuildTitle")}</h3>
              <p>{t("websiteRebuildText")}</p>
            </li>
            <li>
              <h3>{t("ongoingMaintenanceTitle")}</h3>
              <p>{t("ongoingMaintenanceText")}</p>
            </li>
          </ul>
          <CTAButton class="cta-button" href="mailto:contact@aurelieplane.com?subject=Hi there!">{t("getintouch")}</CTAButton>
        </Text>
                
        <ImageWrapper>
          <img src={profileImage} alt='Aurélie' />
        </ImageWrapper>           
      </Wrapper>
    );
};

export default Services;